<template>
  <b-table striped fixed :items="items"></b-table>
</template>
<script>
export default {
  data() {
    return {
      items: null,
    };
  },
  props: ["datos"],
  watch: {
    datos() {
      this.items = this.datos;
    },
  }
};
</script>
<style>
table {
  font-size: 1rem  !important;
}
thead {
  background-color: #efefef;
  color: #24C6AB;
}
tr:hover {
  background: none !important;
}
th {
  font-size: 1rem !important;
}
.table-resaltar {
  font-weight: bold;
  background: #ccc;
}
.table-resaltar:hover {
  background: #ccc !important;
}
</style>
